var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.74 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.59,29.6a49.72,49.72,0,1,1-99.43,0",
    fill: "#52933a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,43c-.42-1.47,1.79-2.39,2.18-.63.31,1.43-1.66,1.61-2.22.55-.91-1.71-3.5-.2-2.59,1.51a4.39,4.39,0,0,0,5.11,2,4,4,0,0,0,2.53-5,4.06,4.06,0,0,0-4.93-2.87,4.41,4.41,0,0,0-3,5.3,1.51,1.51,0,0,0,2.9-.8Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17,51.4a5.19,5.19,0,0,0,6.38-3,4.72,4.72,0,0,0-2.78-6,4.61,4.61,0,0,0-6.12,2.18,5.19,5.19,0,0,0,1.77,6.48c1.61,1.07,3.12-1.52,1.52-2.59s-.47-4.23,1.67-3.32c2.52,1.07.61,4.21-1.64,3.37-1.81-.68-2.59,2.22-.8,2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.45,23.75a2.42,2.42,0,0,1,1.73-2.9,2,2,0,0,1,2.28,1.76c.59,2.54-2.95,3.15-4,1.15-.9-1.7-3.49-.19-2.59,1.52a5.42,5.42,0,0,0,6.35,2.44,4.84,4.84,0,0,0,3.06-6.19,5,5,0,0,0-6-3.52,5.45,5.45,0,0,0-3.67,6.54,1.5,1.5,0,0,0,2.89-.8Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.15,26.94a4.34,4.34,0,0,0,5.34-2.54,4,4,0,0,0-2.34-5.06A3.92,3.92,0,0,0,132,21.17a4.36,4.36,0,0,0,1.5,5.47c1.61,1.07,3.11-1.52,1.51-2.59-1-.68-.28-2.52,1-2,1.56.69.29,2.46-1.05,2-1.81-.68-2.59,2.22-.79,2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.95,
    y1: 26.04,
    x2: 128.54,
    y2: 44.38,
    fill: "none",
    stroke: "#112f25",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53,24.15c11.83.81,23.66-.64,35.5.17,1.93.13,1.92-2.87,0-3-11.84-.81-23.67.64-35.5-.17-1.93-.13-1.92,2.87,0,3Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,27.12A60.48,60.48,0,0,0,96.84,40c.73,1.76,3.63,1,2.9-.8a59.74,59.74,0,0,1-3.87-12.88c-.33-1.9-3.22-1.09-2.9.8Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,44.48a153.74,153.74,0,0,0,21.46,4.17c1.92.23,1.9-2.77,0-3a150.12,150.12,0,0,1-20.67-4.06,1.5,1.5,0,0,0-.79,2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9,13.83a4.6,4.6,0,0,0,5.66-2.68A4.2,4.2,0,0,0,68.09,5.8a4.11,4.11,0,0,0-5.45,1.93,4.61,4.61,0,0,0,1.58,5.78c1.61,1.07,3.11-1.52,1.51-2.59-1.22-.83-.34-3,1.2-2.37,1.85.81.39,3-1.23,2.38-1.81-.67-2.59,2.22-.8,2.9Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,20.48c-6.67-3.85-13.84-6.74-20.51-10.59a1.5,1.5,0,0,0-1.52,2.59c6.68,3.85,13.84,6.74,20.52,10.59a1.5,1.5,0,0,0,1.51-2.59Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,8.45a127.82,127.82,0,0,1-22.28,6.43c-1.9.37-1.09,3.26.8,2.9a128.73,128.73,0,0,0,22.28-6.44c1.78-.69,1-3.59-.8-2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.92,18a2.12,2.12,0,0,1,1.52-2.56,1.79,1.79,0,0,1,2,1.56c.52,2.24-2.6,2.74-3.53,1s-3.49-.19-2.59,1.51a5.14,5.14,0,0,0,6,2.32,4.6,4.6,0,0,0,2.92-5.88,4.73,4.73,0,0,0-5.74-3.35A5.17,5.17,0,0,0,33,18.76a1.51,1.51,0,0,0,2.9-.8Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,0C93.31,1.33,94,2.45,94.92,3.07a15.7,15.7,0,0,0,3.74,1.19A18.24,18.24,0,0,0,95.8,7.08a16.92,16.92,0,0,0-1.23,3.78A16.4,16.4,0,0,0,91.94,8a18.47,18.47,0,0,0-3.75-1.37A16.44,16.44,0,0,0,91,3.92C91.57,3,91.68,1.67,92.15,0Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.22,3.74A11,11,0,0,0,115,5.68a9.89,9.89,0,0,0,2.37.75,11.68,11.68,0,0,0-1.8,1.78,10.46,10.46,0,0,0-.78,2.39,11.3,11.3,0,0,0-1.66-1.78A11.46,11.46,0,0,0,110.71,8a10,10,0,0,0,1.76-1.73A10.87,10.87,0,0,0,113.22,3.74Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3,59a12.68,12.68,0,0,0,1.57,2.67,12.1,12.1,0,0,0,2.58,1.44,13.74,13.74,0,0,0-2.52,1.64,12.38,12.38,0,0,0-1.47,2.6,12.32,12.32,0,0,0-1.52-2.47,13.82,13.82,0,0,0-2.56-1.57,12.46,12.46,0,0,0,2.46-1.6A12.9,12.9,0,0,0,107.3,59Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.35,30.43c1.76.77,2.9,1.57,4.14,1.74s2.55-.31,4.23-.57a19.83,19.83,0,0,0-1.51,4.1c-.15,1.23.29,2.53.54,4.29a17.85,17.85,0,0,0-3.89-1.57,20.63,20.63,0,0,0-4.33.39,17.65,17.65,0,0,0,1.47-4C38.14,33.59,37.66,32.29,37.35,30.43Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,60a252.47,252.47,0,0,0-9.88-24.11,1.53,1.53,0,0,0-2-.54L61.1,39.66a1.52,1.52,0,0,0-.69,1.7c2.82,7.6,6.64,14.8,9.32,22.46a1.53,1.53,0,0,0,1.85,1.05l9.19-3.07c1.82-.61,1-3.51-.8-2.89L70.78,62,72.63,63c-2.69-7.67-6.51-14.87-9.32-22.47l-.69,1.69L71.4,37.9l-2.05-.54a243.1,243.1,0,0,1,9.57,23.39C79.53,62.58,82.43,61.79,81.82,60Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,42.84C54.27,45.75,47,49.46,39,51.42a1.52,1.52,0,0,0-.89,2.2l6.78,15.73a1.52,1.52,0,0,0,1.7.69q12.21-3.39,24-7.89c1.79-.68,1-3.58-.8-2.89q-11.83,4.5-24,7.89l1.69.69L40.69,52.11l-.9,2.2c8-2,15.27-5.66,22.91-8.58,1.79-.68,1-3.58-.8-2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.18,53.59C33.39,55.48,27.79,57.9,22,59.8A1.52,1.52,0,0,0,21,61.64l4.87,12.51a1.54,1.54,0,0,0,1.85,1c6-2.25,12-4.73,17.95-7.21,1.76-.74,1-3.64-.8-2.9-6,2.49-11.9,5-17.95,7.21l1.85,1L23.84,60.84l-1,1.85C28.59,60.8,34.18,58.37,40,56.48c1.83-.6,1-3.49-.8-2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.49,79.09c4.41-1.67,8.75-3.51,13.1-5.36,1.77-.75.25-3.33-1.51-2.59C21,72.88,16.86,74.62,12.69,76.2c-1.79.68-1,3.58.8,2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.11,61.79c-4.3,1.75-8.68,3.27-13.08,4.77-1.82.62-1,3.51.8,2.89,4.4-1.5,8.77-3,13.08-4.77,1.76-.71,1-3.62-.8-2.89Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.47,79.65c-1.76-4.7-4.22-9-5.67-13.86a1.52,1.52,0,0,0-2.2-.89L.74,67.37a1.51,1.51,0,0,0-.69,1.7C1.5,73.9,4,78.22,5.72,82.93a1.53,1.53,0,0,0,2.2.89l5.86-2.47c1.77-.75.24-3.34-1.52-2.6L6.4,81.23l2.21.9c-1.76-4.7-4.22-9-5.67-13.86L2.25,70l5.86-2.47-2.2-.9c1.45,4.83,3.91,9.16,5.66,13.86C12.24,82.24,15.15,81.46,14.47,79.65Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.92,70.72c-4.76.5-7.63,4-7.19,8.87.48,5.23,3.22,8.46,8.66,8.54A8.52,8.52,0,0,0,48,79.24c-.2-5-4.17-9.29-9.34-8.61-1.89.25-1.91,3.26,0,3,7.7-1,8.68,11.54.69,11.5-3.24,0-5-1.56-5.52-4.6-.59-3.24.4-6.43,4.05-6.81,1.9-.2,1.92-3.21,0-3Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,87.07q-.68,12.14-.36,24.27c0,1.93,3,1.94,3,0q-.32-12.15.36-24.27c.11-1.93-2.89-1.93-3,0Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,83.86A273.55,273.55,0,0,0,16.47,112c-.84,1.73,1.75,3.25,2.59,1.51A274.61,274.61,0,0,1,34.82,85.37c1-1.63-1.55-3.13-2.59-1.51Z",
    fill: "#112f25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,86.25c7.49,7.41,12.35,17,19.77,24.45a1.5,1.5,0,0,0,2.12-2.12c-7.42-7.44-12.28-17-19.76-24.46a1.51,1.51,0,0,0-2.13,2.13Z",
    fill: "#112f25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.5f1727e78b362a5c279573aceeb33b65.svg";
export { ForwardRef as ReactComponent };